import { useEffect, useState } from 'react';
import isEqual from 'hs-lodash/isEqual';
export const useDisplayedData = (data, isLoading) => {
  const [displayedData, setDisplayedData] = useState(); // we tried to use 'useMemo' here but there is no easy way
  // to just keep the last 'non-loading' value

  useEffect(() => {
    if (!isLoading && !isEqual(data, displayedData)) {
      setDisplayedData(data);
    }
  }, [isLoading, data, displayedData]);
  return displayedData;
};